module.exports = __webpack_public_path__ + "img/alf_ava.fda5c9ef.jpeg";